export const INVITE = 'INVITE';

export const INVITE_USER_REQUEST = `${INVITE}/inviteUserRequest`;
export const LIST_USER_REQUEST = `${INVITE}/listInviteRequest`;
export const REMOVE_USER_REQUEST = `${INVITE}/removeInviteRequest`;
